module.exports = __webpack_public_path__ + "static/media/next-grey.15d9bbe0.svg";